module.exports = __webpack_public_path__ + "img/uzb.b5e7c761.svg";